const DEFAULT_SITE_URL = "https://kurb.online";

const getSiteHost = () => {
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL?.trim() || DEFAULT_SITE_URL;

  try {
    return new URL(siteUrl).hostname;
  } catch {
    return new URL(DEFAULT_SITE_URL).hostname;
  }
};

export const getAppRouteFromUrl = (rawUrl: string) => {
  if (!rawUrl) {
    return null;
  }

  try {
    const url = new URL(rawUrl);
    const suffix = `${url.search}${url.hash}`;

    if (url.protocol === "http:" || url.protocol === "https:") {
      const siteHost = getSiteHost();

      if (url.hostname !== siteHost && url.hostname !== `www.${siteHost.replace(/^www\./, "")}`) {
        return null;
      }

      return `${url.pathname || "/"}${suffix}`;
    }

    if (url.protocol === "clerk:" && url.hostname === "com.kurb.app.callback") {
      return `/callback${suffix}`;
    }

    const path = `${url.hostname}${url.pathname}`.replace(/^\/?/, "/");

    return `${path || "/"}${suffix}`;
  } catch {
    return null;
  }
};

export const isNativeClerkCallbackUrl = (rawUrl: string) => {
  try {
    const url = new URL(rawUrl);
    return (
      (url.protocol === "clerk:" && url.hostname === "com.kurb.app.callback") ||
      (url.protocol === "com.kurb.app:" && url.hostname === "callback") ||
      (url.protocol === "com.kurbonline.app:" && url.hostname === "callback")
    );
  } catch {
    return false;
  }
};
